module.exports = __webpack_public_path__ + "4c242dc7edc4ef5e42e986d0fc62619b.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/UA.svg
// module id = 6Fh7
// module chunks = 0